module.exports = __webpack_public_path__ + "static/media/proWithGyro.004f3d9a.png";